/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Heben Sie wichtige Botschaften mit einem Spotlight visuell hervor. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Weitere Informationen zu Spotlights',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Heben Sie wichtige Botschaften mit einem Spotlight visuell hervor.',
  'company-hub.spotlight-extension.config-panel.title': 'Spotlight',
  'company-hub.spotlight-extension.hub-element.description': 'Heben Sie wichtige Botschaften hervor.',
  'company-hub.spotlight-extension.hub-element.title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Foto einer Wüstenlandschaft',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Gestalten Sie ein Spotlight, um entscheidende Informationen hervorzuheben. Mit anpassbaren Farben, einem aussagekräftigen Bild und flexiblen Layouts können Sie die wichtigsten Botschaften unterstreichen.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Wählen Sie einen Titel für Ihr Spotlight',
  'company-hub.spotlight-extension.manifest.macro-description':
    'Heben Sie wichtige Botschaften mit einem Spotlight visuell hervor.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Spotlight [neu]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Inhalt',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'Allgemein',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Layouts',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Textfeldüberlagerung auf einem großen Bild',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Inhaltsrahmen innerhalb des Bildes',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Bild in voller Größe hinter Ihrem Inhalt',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Bildhintergrund',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Inhalt vor einer Farbe in voller Breite',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label':
    'Einfarbiger Hintergrund',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Großes Bild auf der rechten Seite mit viel Platz für Inhalt',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Geteiltes Design (Inhalt zuerst)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Großes Bild auf der linken Seite mit viel Platz für Inhalt',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Geteiltes Design (Bild zuerst)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Stile',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Beschreibung',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Mit Spotlights können Sie wichtige Botschaften für Ihr Team hervorheben. Zur Gestaltung des Spotlights können Sie ein Bild, eigene Farben, eine kurze Beschreibung und einen Link verwenden.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Bild',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Titel',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder':
    'Wählen Sie einen Titel für Ihr Spotlight',
  'company-hub.spotlight-extension.spotlight.background.color': 'Hintergrundfarbe',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Ihre Text- und Hintergrundfarben sind mit Blick auf die Lesbarkeit nicht gut geeignet.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Der Text und die Hintergrundfarben sind mit Blick auf die Lesbarkeit gut geeignet.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Textfarbe',
};
